import React, { useCallback, useEffect, useState } from 'react'
import { useOutletContext, useParams } from 'react-router-dom';
import './QuestionsDetails.scss';
import { GetWord } from '../../../../../utils';
import Service from '../../../../../Service';



const QuestionsDetails = () => {
    const [pageName, setPageName] = useOutletContext();

    const [data, setData] = useState(null);
    const [userData, setUserData] = useState(null);
    const { questionId } = useParams();
    const getQuestionsByIdData = useCallback(() => {
        const service = new Service();
        service.AdminService.getQuestionsById(questionId).then((res) => {
            setData(res);
        })
    }, [questionId])

    const getUserData = useCallback(() => {
        const service = new Service();
        service.AdminService.getUserDetail(data?.question?.userId).then((res) => {
            setUserData(res);
        })
    }, [data])

    useEffect(() => {
        getQuestionsByIdData();
    }, [getQuestionsByIdData])

    useEffect(() => {
        if (data) {
            getUserData();
        }
    }, [data, getUserData])

    setPageName(GetWord("Soru Detayı"));


    return (
        <div>

            <div className='QuestionsDetails-FirstArea'>
                <div className='QuestionsDetails-FirstArea-Style'>
                    <p className='QuestionsDetails-FirstArea-Text'>{data?.askerUser?.name} {data?.askerUser?.surname}</p>
                    <p className='QuestionsDetails-FirstArea-Text'>{data?.askerUser?.email}</p>
                    <p className='QuestionsDetails-FirstArea-Text'>Aktif Aboneliği: Aylık 100 Soru</p>
                    <p className='QuestionsDetails-FirstArea-Text'>Soruyu Cevaplayan Eğitmen: {data?.teacherUser?.name} {data?.teacherUser?.surname}</p>
                    <p className='QuestionsDetails-FirstArea-Text'>Puan: {data?.question?.point}</p>
                    <p className='QuestionsDetails-FirstArea-Text'>Soru Hakkı: {userData?.points} </p>
                    <p className='QuestionsDetails-FirstArea-Text'>Şık: {data?.question?.answerOption}</p>
                    <p className='QuestionsDetails-FirstArea-Text'>Yorum: Hızlı Çözün</p>
                </div>
                <div className='QuestionsDetails-FirstArea-Annotation'>
                    <p className='QuestionsDetails-FirstArea-Annotation-AnnotationTitle'>Ek Açıklama:</p>
                    <p className='QuestionsDetails-FirstArea-Annotation-MessageTitle'>Öğrenci:</p>
                    <p className='QuestionsDetails-FirstArea-Annotation-Message'>{data?.questionMessage}</p>
                    <p className='QuestionsDetails-FirstArea-Annotation-MessageTitle'>Eğitmen:</p>
                    <p className='QuestionsDetails-FirstArea-Annotation-Message'>{data?.questionMessageAnswer}</p>

                </div>


            </div>
            <div className='QuestionsDetails-SecondArea'>
                <div>
                    <p className='QuestionsDetails-SecondArea-Text'>Soru:</p>
                    <img src={data?.image} className='QuestionsDetails-SecondArea-Question' alt='' />
                </div>
                <div>
                    <p className='QuestionsDetails-SecondArea-Text'>Cevap:</p>
                    <img src={data?.answerImage} className='QuestionsDetails-SecondArea-Question' alt='' />
                </div>

            </div>


        </div>
    )
}

export default QuestionsDetails
